import React from 'react';
import { Form, Input } from 'antd';

interface Props {
  label: string,
  paramName: string,
  placeholder: string,
}

function InputFormItem({
  label,
  paramName,
  placeholder,
}: Props): JSX.Element {
  return (
    <Form.Item
      label={label}
      name={paramName}
      rules={[
        {
          required: true,
          message: 'Este campo es obligatorio',
        },
      ]}
    >
      <Input placeholder={placeholder} style={{ width: '90%' }} />
    </Form.Item>
  );
}

export default InputFormItem;
